// 액션!=
import createActions from "../controller/createActions";

const { read } = createActions("settings");

export const actionGetSettingsList = () => read({});
